import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const RegistrationComplete = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get policy holder registry data from navigation state
  const policyholderRegistry = location.state?.policyholderRegistry;

  useEffect(() => {
    // Redirect to home if no registry data
    if (!policyholderRegistry || !Object.keys(policyholderRegistry).length) {
      navigate('/');
    }
  }, [policyholderRegistry, navigate]);

  if (!policyholderRegistry) {
    return null; // Will redirect in useEffect
  }

  const handleContinueToLogin = () => {
    window.location.href = '/account-management';
  };

  return (
    <div className="container">
      <Card>
        <div className="grid">
          <div className="col-12">
            <h1 className="text-primary text-4xl font-bold mb-4">Registration Complete</h1>
            
            <h2 className="text-2xl mb-4">
              Congratulations {policyholderRegistry.fullName} of {policyholderRegistry.insuredName}. 
              Your user-ID is: <strong>{policyholderRegistry.userId}</strong>
            </h2>
            
            <div className="mb-4">
              <p className="line-height-3">
                You have successfully completed the policyholder registration procedure. You will be prompted for your user-id and password when attempting to access the Policyholder information Menu page.
                {' '}<strong>Do NOT use REGISTER again.</strong> You may add users via the normal LOGIN procedure.
                If you have questions about this site or experience any difficulties please click here to contact our
                {' '}<strong>
                  <a href="mailto:portalsupport@ri-net.com" className="text-primary">Help Desk</a> or Call 818-382-1007, Monday to Friday, 8:00 a.m. to 4:00 p.m., during business hours.
                </strong>
              </p>
            </div>
            
            <div className="mt-4">
              <Button
                label="Continue to login"
                severity="warning"
                size="large"
                onClick={handleContinueToLogin}
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default RegistrationComplete;
